export default __webpack_public_path__ + "static/media/07.030044dd.jpg";